<template>
    <v-card class="d-flex align-center ga-3 mb-4 pa-2">
        <v-avatar color="rb-primary-light" rounded="lg" size="38">
            <v-icon :icon="icon" color="primary" size="21" />
        </v-avatar>

        <div>
            <div class="text-subtitle-2 font-weight-bold">
                {{ title }}
            </div>

            <div v-if="description" class="text-caption font-weight-medium text-medium-emphasis">
                {{ description }}
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "SectionHeader",
    props: {
        icon: {
            type: String,
            default: "mdi-information-outline",
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: "",
        },
    },
};
</script>
